/** Identifies a `/fat-specification-templates` row as a Coating checklist template (separate from FAT). */
export const COATING_CHECKLIST_SPEC_CATEGORY = 'COATING_CHECKLIST_TEMPLATE';

/** Shown in forms; API category is `COATING_CHECKLIST_SPEC_CATEGORY`. */
export const COATING_CHECKLIST_SPEC_LABEL = 'Coating checklist';
